const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3001'

class CritterApiService {
  constructor() {
    this.broadcasterLogin = null
  }

  setBroadcasterLogin(login) {
    this.broadcasterLogin = login
  }

  getBaseUrl() {
    if (!this.broadcasterLogin) {
      throw new Error('Broadcaster login not set')
    }
    return `${API_BASE}/twitch/api/broadcaster/${this.broadcasterLogin}/critters`
  }

  async loadCritters() {
    try {
      const response = await fetch(this.getBaseUrl(), {
        credentials: 'include'
      })

      if (!response.ok) {
        throw new Error(`Failed to load critters: ${response.status}`)
      }

      const critters = await response.json()
      console.log(`Loaded ${critters.length} critters from database`)
      return critters
    } catch (error) {
      console.error('Error loading critters:', error)
      return []
    }
  }

  async addCritter(userId, username, critterType = 'ferret') {
    try {
      const response = await fetch(this.getBaseUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ userId, username, critterType })
      })

      if (!response.ok) {
        const error = await response.json()
        console.error('Failed to add critter:', error)
        return null
      }

      const critter = await response.json()
      console.log(`Added critter for ${username} to database`)
      return critter
    } catch (error) {
      console.error('Error adding critter:', error)
      return null
    }
  }

  async updateCritterType(userId, critterType) {
    try {
      const response = await fetch(`${this.getBaseUrl()}/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ critterType })
      })

      if (!response.ok) {
        const error = await response.json()
        console.error('Failed to update critter:', error)
        return null
      }

      const critter = await response.json()
      console.log(`Updated critter type for ${userId}`)
      return critter
    } catch (error) {
      console.error('Error updating critter:', error)
      return null
    }
  }

  async removeCritter(userId) {
    try {
      const response = await fetch(`${this.getBaseUrl()}/${userId}`, {
        method: 'DELETE',
        credentials: 'include'
      })

      if (!response.ok) {
        const error = await response.json()
        console.error('Failed to remove critter:', error)
        return false
      }

      console.log(`Removed critter ${userId} from database`)
      return true
    } catch (error) {
      console.error('Error removing critter:', error)
      return false
    }
  }

  async removeCritterByUsername(username) {
    try {
      const response = await fetch(`${this.getBaseUrl()}/by-username/${encodeURIComponent(username)}`, {
        method: 'DELETE',
        credentials: 'include'
      })

      if (!response.ok) {
        const error = await response.json()
        console.error('Failed to remove critter:', error)
        return false
      }

      console.log(`Removed critter for ${username} from database`)
      return true
    } catch (error) {
      console.error('Error removing critter:', error)
      return false
    }
  }

  async removeAllCritters() {
    try {
      const response = await fetch(this.getBaseUrl(), {
        method: 'DELETE',
        credentials: 'include'
      })

      if (!response.ok) {
        const error = await response.json()
        console.error('Failed to remove all critters:', error)
        return false
      }

      const result = await response.json()
      console.log(`Removed ${result.removed} critters from database`)
      return true
    } catch (error) {
      console.error('Error removing all critters:', error)
      return false
    }
  }
}

// Singleton instance
export const critterApi = new CritterApiService()
export default critterApi
